import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { DomainsModule } from '@galaxy/email-ui/domain-authorization/src/domains/domains.module';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { DNSService } from '../../core/dns';
import { AdvancedSettingsComponent } from '../advanced-settings/advanced-settings.component';
import { AppDialogModule } from '../dialog';
import { AddDomainDialogComponent } from './add-domain/add-domain.component';
import { CustomDomainComponent } from './add-domain/custom-domain.component';
import { DeleteDomainDialogComponent } from './delete-domain/delete-domain.component';
import { DomainInstructionComponent } from './domain-instruction.component';
import { DetailRowDirective } from './domain-manager-row.directive';
import { DomainManagerComponent } from './domain-manager.component';
import { DomainMessagesService } from './domain-messages.service';
import { PrimaryDomainDialogComponent } from './primary-domain/primary-domain.component';

const routes: Routes = [
  {
    path: '',
    component: DomainManagerComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    RouterModule.forChild(routes),
    AppDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatDialogModule,
    MatCheckboxModule,
    GalaxySnackbarModule,
    MatTableModule,
    MatIconModule,
    AdvancedSettingsComponent,
    MatChipsModule,
    MatInputModule,
    MatTooltipModule,
    OverlayModule,
    GalaxyPopoverModule,
    GalaxyPageModule,
    ClipboardModule,
    MatSnackBarModule,
    DomainsModule,
    GalaxyButtonLoadingIndicatorModule,
  ],
  declarations: [
    AddDomainDialogComponent,
    DeleteDomainDialogComponent,
    PrimaryDomainDialogComponent,
    DomainManagerComponent,
    CustomDomainComponent,
    DetailRowDirective,
    DomainInstructionComponent,
  ],
  exports: [RouterModule],
  providers: [DomainMessagesService, DNSService],
})
export class DomainManagerModule {}
